var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.6673 12.25V11.0833C11.6673 10.4645 11.4215 9.871 10.9839 9.43342C10.5463 8.99583 9.95282 8.75 9.33398 8.75H4.66732C4.04848 8.75 3.45499 8.99583 3.0174 9.43342C2.57982 9.871 2.33398 10.4645 2.33398 11.0833V12.25",
  stroke: "#666666",
  strokeWidth: 1.16667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.99935 6.41667C8.28801 6.41667 9.33268 5.372 9.33268 4.08333C9.33268 2.79467 8.28801 1.75 6.99935 1.75C5.71068 1.75 4.66602 2.79467 4.66602 4.08333C4.66602 5.372 5.71068 6.41667 6.99935 6.41667Z",
  stroke: "#666666",
  strokeWidth: 1.16667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIconUser;